module.exports = __webpack_public_path__ + "static/media/desayunosbrunch_checked.86391155.svg";